// @flow
import React from "react";
import {reisy, use} from "reisy";
import {observer} from "mobx-react";
import type {Story} from "../api/types.js";
import type {Position} from "../scroller/utils.js";

const styles = reisy`
@namespace PageIndicator;

JackInTheBox: $Settings.JackInTheBox;
Color: hsl(90, 0%, 70%);

Wrapper {
	position: fixed;
	top: 0; left: 0; right: 0;
	width: 100%;
	z-index: 50;
	overflow: hidden;
	height: 4px;
	margin-bottom: -4px;
}

Bar {
	background: $Color;
	opacity: 0.75;

	height: 100%;
	transition: all $Consts.Transition;
}

Sticky {
	position: sticky;
}
`;

type Props = {
	position: Position;
	story: Story;
	startsAt: number;
};

const PageIndicator = ({position, story, startsAt}: Props) => {
	const max = story.pages.length - 1;
	if (max <= 0) { return null; }
	const current = Math.max(0, Math.min(position.target - startsAt, max));
	const transform = `translateX(${(current / max) * 100 - 100}%)`;
	return (
		<div
			{...use(
				styles.Wrapper,
				styles.JackInTheBox && styles.Sticky
			)} >
			<div
				{...use(
					styles.Bar,
					{transform}
				)} />
		</div>
	);
};

export default observer(PageIndicator);



// WEBPACK FOOTER //
// ./lib/components/pageindicator.js